export default __webpack_public_path__ + "static/kb_2_main-eb2b14abaae9912cedf964b14c3b28e2.jpeg";